import React from 'react';
import { Card, ListGroup, Row, Col } from 'react-bootstrap';
import { format } from 'date-fns';
import { TaskCommentsListProps } from '../types/types';

const TaskComments: React.FC<TaskCommentsListProps> = ({ comments, users }) => {
  if (!comments || comments.length === 0) {
    return (
      <Card className="shadow-sm mt-4">
        <Card.Body className="p-4">
          <h5 className="mb-3 fw-bold d-flex align-items-center">
            <i className="bi bi-chat-left-text me-2"></i>Comments
          </h5>
          <div className="text-center py-4">
            <i className="bi bi-chat-square-text fs-1 text-muted"></i>
            <p className="text-muted mt-2">No comments for this task</p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="shadow-sm mt-4">
      <Card.Body className="p-4">
        <h5 className="mb-3 fw-bold d-flex align-items-center">
          <i className="bi bi-chat-left-text me-2"></i>Comments (
          {comments.length})
        </h5>
        <ListGroup variant="flush">
          {comments.map(comment => {
            const user = users[comment.userId] || {
              firstName: 'Unknown',
              lastName: 'User',
              email: '',
              username: ''
            };

            return (
              <ListGroup.Item
                key={(comment as any).id || comment._id || comment.createdAt}
                className="border-bottom py-3"
              >
                <Row>
                  <Col xs={12} className="d-flex">
                    <div
                      className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 me-3"
                      style={{ width: '40px', height: '40px' }}
                    >
                      {user.firstName?.charAt(0)}
                      {user.lastName?.charAt(0)}
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-bold mb-0">
                          {user.firstName || 'Unknown'} {user.lastName || ''}
                        </h6>
                        <small className="text-muted">
                          {format(
                            new Date(comment.createdAt),
                            'MMM dd, yyyy HH:mm'
                          )}
                          {comment.editedAt && (
                            <span className="ms-2 fst-italic">(edited)</span>
                          )}
                        </small>
                      </div>
                      <div className="comment-text">{comment.text}</div>
                    </div>
                  </Col>
                </Row>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default TaskComments;
